(function initializeZenSections() {
'use strict';
for (const sectionRoot of document.querySelectorAll('[data-zenencens-customizer]')) {
if (sectionRoot.dataset.zenReady) continue;
sectionRoot.dataset.zenReady = 'true';
(function () {
﻿const ZEN_CATALOG = window.ZENENCENS_CATALOG;
    if (!ZEN_CATALOG) throw new Error('Catalogue Zenencens indisponible');
    const STONES = ZEN_CATALOG.stones;
    const stoneLabel = stone => stone.displayName || stone.name;
    const PRESET_SIZES = [14, 15, 16, 17, 18, 19, 20, 21];
    const BEAD_SIZES = ZenCore.sizes;
    const PRICE_LIST = ZEN_CATALOG.prices;
    const STONE_TEXTURES = { ...ZEN_CATALOG.textures };
        const ZEN_ROOT = sectionRoot;
    const ZEN_CONFIG_NODE = ZEN_ROOT ? ZEN_ROOT.querySelector("[data-zen-config]") : null;
    const ZEN_CONFIG = ZEN_CONFIG_NODE ? JSON.parse(ZEN_CONFIG_NODE.textContent || "{}") : {};
    const SHOPIFY_PRODUCT = ZEN_CONFIG.product || {};
    const LOCAL_PREVIEW = ZEN_CONFIG.previewMode === true && (window.location.protocol === 'file:' || ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname));
    if (ZEN_CONFIG.stoneTextures) Object.assign(STONE_TEXTURES, ZEN_CONFIG.stoneTextures);
    let premiumViewerCleanup = null;
    let premiumViewerUpdate = null;
    const premiumMaterialCache = new Map();
    let premiumTextureLoader = null;

    function destroyPremiumViewer() {
      if (premiumViewerCleanup) premiumViewerCleanup();
      premiumViewerCleanup = null;
      premiumViewerUpdate = null;
    }

    function loadPremiumTexture(textureUrl, onLoad, onError) {
      const embeddedTexture = window.ZENENCENS_TEXTURE_DATA && window.ZENENCENS_TEXTURE_DATA[textureUrl];
      if (embeddedTexture || window.location.protocol === "file:") {
        if (!embeddedTexture) {
          onError(new Error(`Embedded texture missing: ${textureUrl}`));
          return;
        }
        const image = new Image();
        image.decoding = "async";
        image.onload = () => {
          const texture = new THREE.Texture(image);
          texture.needsUpdate = true;
          onLoad(texture);
        };
        image.onerror = onError;
        image.src = embeddedTexture;
        return;
      }
      premiumTextureLoader = premiumTextureLoader || new THREE.TextureLoader();
      premiumTextureLoader.load(textureUrl, onLoad, undefined, onError);
    }

    function premiumStoneMaterial(stoneName, onTextureSettled) {
      if (premiumMaterialCache.has(stoneName)) {
        const cached = premiumMaterialCache.get(stoneName);
        if (onTextureSettled) {
          if (cached.userData.textureSettled) queueMicrotask(onTextureSettled);
          else cached.userData.settleCallbacks.push(onTextureSettled);
        }
        return cached;
      }
      const stone = getStone(stoneName);
      const material = new THREE.MeshPhysicalMaterial({
        color: new THREE.Color(stone.palette[1] || stone.palette[0]),
        roughness: stone.pattern === "lava" ? 0.9 : stoneName === "Obsidienne noire" || stoneName === "Hématite" ? 0.38 : 0.52,
        metalness: stoneName === "Hématite" || stoneName === "Pyrite" ? 0.34 : 0,
        clearcoat: stone.pattern === "lava" ? 0 : 0.08,
        clearcoatRoughness: 0.55,
        reflectivity: 0.32,
        envMapIntensity: 0.45
      });
      material.userData.textureSettled = false;
      material.userData.settleCallbacks = onTextureSettled ? [onTextureSettled] : [];
      premiumMaterialCache.set(stoneName, material);
      const textureUrl = STONE_TEXTURES[stoneName];
      if (textureUrl) {
        loadPremiumTexture(textureUrl, (texture) => {
          texture.encoding = THREE.sRGBEncoding;
          texture.wrapS = THREE.RepeatWrapping;
          texture.wrapT = THREE.RepeatWrapping;
          texture.repeat.set(1.12, 1.08);
          texture.anisotropy = 8;
          material.map = texture;
          material.color.set(0xffffff);
          material.needsUpdate = true;
          material.userData.textureSettled = true;
          material.userData.settleCallbacks.splice(0).forEach((callback) => callback());
        }, () => {
          material.userData.textureSettled = true;
          material.userData.settleCallbacks.splice(0).forEach((callback) => callback());
        });
      } else {
        material.userData.textureSettled = true;
        material.userData.settleCallbacks.splice(0).forEach((callback) => callback());
      }
      return material;
    }

    function initPremiumViewer(shell) {
      destroyPremiumViewer();
      const canvas = shell.querySelector("#braceletCanvas");
      const loading = shell.querySelector("#viewerLoading");
      if (!canvas || typeof THREE === "undefined" || typeof THREE.OrbitControls === "undefined") {
        shell.innerHTML = `<div class="viewer-fallback">La vue 3D nécessite une connexion pour charger le moteur d’affichage.</div>`;
        return;
      }

      let renderer;
      try { renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: "low-power" }); }
      catch (error) { shell.innerHTML = '<div class="viewer-fallback">La vue 3D est indisponible. Retrouvez chaque perle dans la composition ci-dessous.</div>'; return; }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 0.95;

      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(34, 1, 0.1, 100);
      camera.position.set(0, 5.3, 8.3);

      const environmentCanvas = document.createElement("canvas");
      environmentCanvas.width = 512;
      environmentCanvas.height = 256;
      const environmentContext = environmentCanvas.getContext("2d");
      const studioGradient = environmentContext.createLinearGradient(0, 0, 512, 0);
      studioGradient.addColorStop(0, "#3f4650");
      studioGradient.addColorStop(0.16, "#fbf7ef");
      studioGradient.addColorStop(0.33, "#737b84");
      studioGradient.addColorStop(0.5, "#ffffff");
      studioGradient.addColorStop(0.68, "#59616c");
      studioGradient.addColorStop(0.84, "#f4dfbf");
      studioGradient.addColorStop(1, "#343b44");
      environmentContext.fillStyle = studioGradient;
      environmentContext.fillRect(0, 0, 512, 256);
      const verticalFade = environmentContext.createLinearGradient(0, 0, 0, 256);
      verticalFade.addColorStop(0, "rgba(255,255,255,.8)");
      verticalFade.addColorStop(0.42, "rgba(255,255,255,0)");
      verticalFade.addColorStop(1, "rgba(45,35,28,.45)");
      environmentContext.fillStyle = verticalFade;
      environmentContext.fillRect(0, 0, 512, 256);
      const environmentTexture = new THREE.CanvasTexture(environmentCanvas);
      environmentTexture.encoding = THREE.sRGBEncoding;
      environmentTexture.mapping = THREE.EquirectangularReflectionMapping;
      const environmentTarget = new THREE.WebGLCubeRenderTarget(128);
      environmentTarget.fromEquirectangularTexture(renderer, environmentTexture);
      scene.environment = environmentTarget.texture;

      scene.add(new THREE.HemisphereLight(0xfff8ed, 0x69533e, 1.08));
      const key = new THREE.DirectionalLight(0xfff5e6, 1.15);
      key.position.set(4.5, 7.5, 5.5);
      key.castShadow = true;
      key.shadow.mapSize.set(1024, 1024);
      key.shadow.camera.left = -6; key.shadow.camera.right = 6; key.shadow.camera.top = 6; key.shadow.camera.bottom = -6;
      scene.add(key);
      const rim = new THREE.DirectionalLight(0xd7b078, 0.5);
      rim.position.set(-5, 3.5, -4.5);
      scene.add(rim);
      const whiteCard = new THREE.PointLight(0xffffff, 0.3, 18);
      whiteCard.position.set(-1.5, 3.2, 5.5);
      scene.add(whiteCard);
      const steelCard = new THREE.PointLight(0xdbe8ff, 0.62, 14);
      steelCard.position.set(4.2, 1.4, -1.8);
      scene.add(steelCard);

      const controls = new THREE.OrbitControls(camera, canvas);
      controls.enablePan = false;
      controls.enableDamping = true;
      controls.dampingFactor = 0.075;
      controls.minDistance = 6.2;
      controls.maxDistance = 11.5;
      controls.minPolarAngle = Math.PI * 0.18;
      controls.maxPolarAngle = Math.PI * 0.5;
      controls.autoRotate = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      controls.autoRotateSpeed = 0.68;
      controls.target.set(0, 0, 0);

      let resumeTimer = 0;
      controls.addEventListener("start", () => { controls.autoRotate = false; window.clearTimeout(resumeTimer); });
      controls.addEventListener("end", () => { resumeTimer = window.setTimeout(() => { controls.autoRotate = !window.matchMedia("(prefers-reduced-motion: reduce)").matches; }, 2400); });

      const braceletGroup = new THREE.Group();
      braceletGroup.rotation.x = -0.04;
      scene.add(braceletGroup);
      const beadGeometry = new THREE.SphereGeometry(1, 48, 32);
      const clickableBeads = [];
      let pendingTextures = 0;
      let viewerRevision = 0;
      let selectionHalo = null;

      const signatureGeometries = {6: ZenSignature.geometry(THREE, 6, 5), 8: ZenSignature.geometry(THREE, 8, 5)};
      const signatureMaterials = {};
      const plainSteel = new THREE.MeshPhysicalMaterial({color: 0xc9ccce, metalness: 0.8, roughness: 0.32, envMapIntensity: 0.75});
      const logo = new Image(); logo.crossOrigin = 'anonymous';
      let viewerDisposed = false;
      logo.onload = () => {
        if (viewerDisposed) return;
        try { for (const size of [6, 8]) signatureMaterials[size] = ZenSignature.material(THREE, logo, size, 5); premiumViewerUpdate(); }
        catch (error) { console.warn('Zenencens signature logo unavailable', error); }
      };
      logo.src = window.ZENENCENS_SIGNATURE_LOGO || ZEN_ROOT.querySelector('img').dataset.signatureLogo || ZEN_ROOT.querySelector('img').src;

      premiumViewerUpdate = () => {
      const revision = ++viewerRevision;
      while (braceletGroup.children.length) braceletGroup.remove(braceletGroup.children[0]);
      clickableBeads.length = 0;
      if (selectionHalo) { selectionHalo.geometry.dispose(); selectionHalo.material.dispose(); selectionHalo = null; }
      const totalSlots = state.beads.length + state.spacerQuantity;
      const radius = 2.72;
      const ring = ZenCore.ringLayout(state.beads, state.cylinderSlot, ZenCore.spacerLength(state));
      let beadIndex = 0;
      pendingTextures = new Set(state.beads.map(bead => bead.stoneName)).size;
      const requestedMaterials = new Set();
      if (loading) loading.classList.remove('is-ready');
      const textureSettled = () => {
        if (revision !== viewerRevision) return;
        pendingTextures = Math.max(0, pendingTextures - 1);
        if (!pendingTextures && loading) loading.classList.add('is-ready');
      };
      for (let slot = 0; slot < totalSlots; slot += 1) {
        const angle = ring[slot].angle;
        const x = radius * Math.cos(angle);
        const z = radius * Math.sin(angle);
        const y = Math.sin(angle * 2) * 0.035;
        if (state.spacerQuantity && slot === state.cylinderSlot) {
          const steelBall = new THREE.Mesh(signatureGeometries[state.spacerSizeMm], signatureMaterials[state.spacerSizeMm] || plainSteel);
          const ballScale = 2 * ring[slot].radiusRatio * radius / 5;
          steelBall.position.set(x, y, z);
          steelBall.scale.setScalar(ballScale);
          steelBall.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), new THREE.Vector3(-Math.sin(angle), 0, Math.cos(angle)));
          const logoFacing = new THREE.Vector3(0, 1, 0).applyQuaternion(steelBall.quaternion.clone().invert());
          steelBall.rotateY(Math.atan2(-logoFacing.x, -logoFacing.z));
          steelBall.userData.signature = true;
          steelBall.castShadow = true;
          braceletGroup.add(steelBall);
          continue;
        }
        const bead = state.beads[beadIndex];
        const shouldTrackTexture = !requestedMaterials.has(bead.stoneName);
        requestedMaterials.add(bead.stoneName);
        const mesh = new THREE.Mesh(beadGeometry, premiumStoneMaterial(bead.stoneName, shouldTrackTexture ? textureSettled : null));
        const beadScale = ring[slot].radiusRatio * radius;
        mesh.position.set(x, y, z);
        mesh.scale.setScalar(beadScale);
        mesh.rotation.set((beadIndex * 0.61) % Math.PI, (beadIndex * 1.17) % Math.PI, (beadIndex * 0.29) % Math.PI);
        mesh.visible = !bead.empty;
        mesh.castShadow = true;
        mesh.receiveShadow = true;
        mesh.userData.beadIndex = beadIndex;
        clickableBeads.push(mesh);
        braceletGroup.add(mesh);
        beadIndex += 1;
      }

      const selectedMesh = clickableBeads[state.selectedBeadIndex];
      if (selectedMesh) {
        const haloMaterial = new THREE.MeshBasicMaterial({ color: 0xe5bd7f, transparent: true, opacity: 0.085, depthWrite: false });
        selectionHalo = new THREE.Mesh(new THREE.SphereGeometry(1, 32, 24), haloMaterial);
        selectionHalo.position.copy(selectedMesh.position);
        selectionHalo.userData.baseScale = selectedMesh.scale.x * 1.28;
        selectionHalo.scale.setScalar(selectionHalo.userData.baseScale);
        braceletGroup.add(selectionHalo);
      }
      };
      premiumViewerUpdate();

      const raycaster = new THREE.Raycaster();
      const pointer = new THREE.Vector2();
      let downX = 0;
      let downY = 0;
      const onPointerDown = (event) => { downX = event.clientX; downY = event.clientY; };
      const onPointerUp = (event) => {
        if (Math.hypot(event.clientX - downX, event.clientY - downY) > 7) return;
        const rect = canvas.getBoundingClientRect();
        pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        pointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        raycaster.setFromCamera(pointer, camera);
        const hit = raycaster.intersectObjects([...clickableBeads, ...braceletGroup.children.filter(mesh => mesh.userData.signature)])[0];
        if (hit?.object.userData.signature) { if (sizeEditMode) { resizeTarget('signature'); return; } ui.preview.querySelector('#signatureControls').scrollIntoView({block:'center'}); ui.preview.querySelector('[data-signature-size]').focus(); return; }
        if (!hit || typeof hit.object.userData.beadIndex !== "number") return;
        const clickedIndex = hit.object.userData.beadIndex;
        if (sizeEditMode) { resizeTarget(clickedIndex); return; }
        if (!available(state.selectedStoneName, state.sizeBrushArmed ? state.selectedApplySizeMm : state.beads[clickedIndex].sizeMm)) { announce("Cette pierre est indisponible dans ce diamètre."); return; }
        mutateComposition(() => {
          state.selectedBeadIndex = clickedIndex;
          state.beads[clickedIndex].stoneName = state.selectedStoneName; state.beads[clickedIndex].empty = false;
          if (state.sizeBrushArmed) {
            state.beads[clickedIndex].sizeMm = state.selectedApplySizeMm;
            state.sizeBrushArmed = false;
          }
        });
      };
      canvas.addEventListener("pointerdown", onPointerDown);
      canvas.addEventListener("pointerup", onPointerUp);

      let lastAspect = 0;
      const resize = () => {
        const width = shell.clientWidth;
        const height = shell.clientHeight;
        if (!width || !height) return;
        renderer.setSize(width, height, false);
        camera.aspect = width / height;
        if (Math.abs(camera.aspect - lastAspect) > 0.01) {
          // Keep the complete ring in view on narrow phones; preserve the viewing angle.
          const fitDistance = 3.45 / Math.tan(THREE.MathUtils.degToRad(camera.fov / 2)) / Math.min(1, camera.aspect);
          camera.position.sub(controls.target).normalize().multiplyScalar(fitDistance).add(controls.target);
          controls.minDistance = fitDistance * 0.8; controls.maxDistance = fitDistance * 1.6;
          lastAspect = camera.aspect;
        }
        camera.updateProjectionMatrix();
      };
      const resizeObserver = new ResizeObserver(resize);
      resizeObserver.observe(shell);
      resize();

      let animationFrame = 0;
      let visibilityTimer = 0;
      const animate = (time) => {
        const bounds = shell.getBoundingClientRect();
        if (document.hidden || !bounds.width || !bounds.height || bounds.bottom <= 0 || bounds.top >= window.innerHeight) {
          // Keep the existing viewer lifecycle; wake cheaply while the dialog is closed.
          visibilityTimer = window.setTimeout(() => {
            visibilityTimer = 0;
            animationFrame = requestAnimationFrame(animate);
          }, 250);
          return;
        }
        controls.update();
        if (selectionHalo && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          const pulse = 1 + Math.sin(time * 0.004) * 0.07;
          selectionHalo.scale.setScalar(selectionHalo.userData.baseScale * pulse);
          selectionHalo.material.opacity = 0.055 + (Math.sin(time * 0.004) + 1) * 0.022;
        }
        renderer.render(scene, camera);
        animationFrame = requestAnimationFrame(animate);
      };
      animationFrame = requestAnimationFrame(animate);
      if (!pendingTextures && loading) loading.classList.add("is-ready");

      premiumViewerCleanup = () => {
        cancelAnimationFrame(animationFrame);
        window.clearTimeout(visibilityTimer);
        window.clearTimeout(resumeTimer);
        resizeObserver.disconnect();
        canvas.removeEventListener("pointerdown", onPointerDown);
        canvas.removeEventListener("pointerup", onPointerUp);
        controls.dispose();
        beadGeometry.dispose();
        viewerDisposed = true; logo.onload = null;
        Object.values(signatureGeometries).forEach(g => g.dispose());
        Object.values(signatureMaterials).forEach(m => { m.map.dispose(); m.dispose(); }); plainSteel.dispose();
        if (selectionHalo) { selectionHalo.geometry.dispose(); selectionHalo.material.dispose(); }
        environmentTarget.dispose();
        environmentTexture.dispose();
        renderer.dispose();
      };
    }

    const state = {
      braceletSizeCm: 18,      baseBeadSizeMm: 8,
      selectedStoneName: "Quartz rose",
      selectedApplySizeMm: 8,
      sizeBrushArmed: false,
      viewerRotation: 0.35,
      viewerTilt: 0.5,
      viewerDragDistance: 0,
      suppressBeadClick: false,
      selectedBeadIndex: 0,
      cylinderSlot: 0, spacerSizeMm: 6, spacerQuantity: 1,
      beads: []
    };

    const STORAGE_KEY = "zenencens-studio-v5";
    const LEGACY_STORAGE_KEYS = ["zenencens-studio-v4", "zenencens-studio-v3"];
    const history = [];
    const future = [];
    const orderForm = { name: "", contact: "", notes: "" };
    let sizeEditMode = false;
    let sizeEditValue = 8;
    function resizeTarget(index) {
      if (cartBusy) return;
      const before = historyEntry();
      if (index === 'signature') {
        if (![6, 8].includes(sizeEditValue)) { announce('L’intercalaire signature existe en 6 et 8 mm uniquement.'); return; }
        if (state.spacerSizeMm === sizeEditValue) return;
        state.spacerSizeMm = sizeEditValue;
      } else {
        const bead = state.beads[index];
        if (!bead) return;
        const entry = ZEN_CONFIG.inventory?.[getStone(bead.stoneName).id]?.sizes?.[sizeEditValue];
        const count = state.beads.filter((b, i) => i !== index && b.stoneName === bead.stoneName && b.sizeMm === sizeEditValue && !b.empty).length + 1;
        if (!Number.isFinite(PRICE_LIST[bead.stoneName]?.[sizeEditValue]) || !available(bead.stoneName, sizeEditValue) || (entry?.quantity !== undefined && count > entry.quantity)) { announce('Cette pierre n’est pas disponible en ' + sizeEditValue + ' mm.'); return; }
        if (bead.sizeMm === sizeEditValue) return;
        bead.sizeMm = sizeEditValue;
        state.selectedBeadIndex = index;
      }
      // Keep the resized bead while compensating at the end using production sizing.
      const previousCount = state.beads.length;
      if (index !== 'signature') {
        const selectedMarker = Symbol('resized bead');
        const marked = state.beads.map((bead, i) => i === index ? { ...bead, [selectedMarker]: true } : bead);
        state.beads = ZenCore.rebalance(marked, getSize(), state.baseBeadSizeMm, index, ZenCore.spacerLength(state));
        state.selectedBeadIndex = state.beads.findIndex(bead => bead[selectedMarker]);
        state.beads.forEach(bead => { delete bead[selectedMarker]; });
        state.selectedApplySizeMm = sizeEditValue;
      }
      const difference = state.beads.length - previousCount;
      const adjustment = difference > 0 ? difference + ' perle(s) en quartz rose ajoutée(s) pour garder la taille.' : difference < 0 ? (-difference) + ' perle(s) retirée(s) en fin de bracelet pour garder la taille.' : '';
      history.push(before); if (history.length > 30) history.shift(); future.length = 0;
      reviewed = false;
      notice = (index === 'signature' ? 'Intercalaire' : 'Perle') + ' passée en ' + sizeEditValue + ' mm. ' + adjustment + ' ' + lengthGuidance();
      render();
    }
    function lengthGuidance() {
      const delta = totalLengthMm() - getSize() * 10;
      if (delta > 0) return 'Réduisez les diamètres : ' + delta + ' mm en trop.';
      if (-delta >= state.baseBeadSizeMm) return 'Augmentez les diamètres : ' + (-delta) + ' mm à compléter.';
      return 'Bracelet complet.';
    }
    let catalogQuery = "";

    const ui = {
      builder: ZEN_ROOT.querySelector("#builderPanel"),
      preview: ZEN_ROOT.querySelector("#previewPanel"),
      project: ZEN_ROOT.querySelector("#projectPanel")
    };

    const getStone = (name) => STONES.find((s) => s.name === name) || STONES[0];
    const stoneTexture = (name) => window.ZENENCENS_TEXTURE_DATA?.[STONE_TEXTURES[name]] || STONE_TEXTURES[name] || null;
    const getSize = () => state.braceletSizeCm;
    const formatEuro = (value) => `${value.toFixed(2)} €`;
    const getStonePrice = (stoneName, sizeMm) => PRICE_LIST[stoneName]?.[sizeMm] ?? 0;
    const totalPrice = () => ZenCore.priceCents(state.beads, PRICE_LIST) / 100;
    const compositionSnapshot = () => ({
      braceletSizeCm: state.braceletSizeCm,
      baseBeadSizeMm: state.baseBeadSizeMm,
      selectedStoneId: getStone(state.selectedStoneName).id,
      selectedStoneName: state.selectedStoneName,
      selectedApplySizeMm: state.selectedApplySizeMm,
      selectedBeadIndex: state.selectedBeadIndex,
      cylinderSlot: state.cylinderSlot, spacerSizeMm: state.spacerSizeMm, spacerQuantity: state.spacerQuantity,
      beads: state.beads.map((bead) => ({ stoneId: getStone(bead.stoneName).id, stoneName: bead.stoneName, sizeMm: bead.sizeMm, empty: !!bead.empty }))
    });
    const draftSnapshot = () => ({ draftSchema: 5, ...compositionSnapshot(), customerNote: orderForm.notes,
      editor: { sizeEditMode, sizeEditValue }, myStoneIds: [...myStoneIds] });
    const historyEntry = () => ({ kind: 'bracelet-composition-v1', configuration: compositionSnapshot() });
    function restoreHistoryEntry(entry) {
      if (!entry || entry.kind !== 'bracelet-composition-v1') throw new Error('Invalid history entry');
      restoreComposition(entry.configuration);
    }

    function restoreComposition(snapshot) {
      const migratedDraft = ZenCore.migrateDraft(snapshot, STONES);
      const legacyNames = migratedDraft.migrated;
      snapshot = migratedDraft.snapshot;
      const legacySpacer = snapshot && snapshot.spacerQuantity === undefined;
      if (legacySpacer) snapshot = { ...snapshot, spacerQuantity: 1, spacerSizeMm: 6, cylinderSlot: 0 };
      if (!ZenCore.valid(snapshot, STONES.map(s => s.name), true)) throw new Error('Invalid saved composition');
      for (const key of ['braceletSizeCm', 'baseBeadSizeMm', 'selectedStoneName', 'selectedApplySizeMm', 'selectedBeadIndex', 'cylinderSlot']) state[key] = snapshot[key];
      state.spacerSizeMm = snapshot.spacerSizeMm || 6;
      state.spacerQuantity = 1; state.cylinderSlot = 0;
      state.beads = snapshot.beads.map(b => ({ stoneName: b.stoneName, sizeMm: b.sizeMm, empty: !!b.empty }));
      if (legacySpacer) state.beads = ZenCore.rebalance(state.beads, state.braceletSizeCm, state.baseBeadSizeMm, state.selectedBeadIndex, 5);
      state.selectedBeadIndex = Math.min(state.selectedBeadIndex, state.beads.length - 1);
      state.sizeBrushArmed = false;
      return { migrated: legacyNames, snapshot };
    }

    function mutateComposition(change, confirmed = false) {
      if (cartBusy) return;
      const before = historyEntry();
      change();
      syncBeads();
      if (!confirmed && state.beads.length < before.configuration.beads.length) {
        const after = historyEntry(); restoreHistoryEntry(before);
        confirmAction('Ajuster votre composition ?', 'Ce changement ramène le bracelet à ' + after.configuration.beads.length + ' perles. Les dernières perles seront ajustées. Vous pourrez annuler.', () => mutateComposition(() => restoreHistoryEntry(after), true));
        return;
      }
      history.push(before);
      if (history.length > 30) history.shift();
      future.length = 0;
      if (state.beads.length > before.configuration.beads.length) notice = 'Votre bracelet comporte maintenant ' + state.beads.length + ' perles. Les nouvelles perles sont en quartz rose ; vous pouvez les personnaliser.';
      else if (state.beads.length < before.configuration.beads.length) notice = 'Composition ajustée à ' + state.beads.length + ' perles. Vous pouvez annuler cette modification.';
      reviewed = false;
      track('bracelet_started');
      if (!state.beads.some(b => b.empty)) track('bracelet_completed');
      render();
    }

    function undoComposition() {
      if (cartBusy) return;
      const previous = history.pop();
      if (!previous) return;
      future.push(historyEntry());
      restoreHistoryEntry(previous);
      reviewed = false; notice = 'Dernière modification annulée.';
      render();
    }

    function redoComposition() {
      if (cartBusy) return;
      const next = future.pop();
      if (!next) return;
      history.push(historyEntry());
      restoreHistoryEntry(next);
      reviewed = false; notice = 'Modification rétablie.';
      render();
    }

    function persistDraft() {
      if (restoreBlocked) return;
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(draftSnapshot())); saveMessage = 'Création enregistrée sur cet appareil'; }
      catch (error) { saveMessage = 'Sauvegarde indisponible sur cet appareil. Gardez cette page ouverte.'; }
    }

    function loadSavedComposition() {
      try {
        const current = localStorage.getItem(STORAGE_KEY);
        const legacy = LEGACY_STORAGE_KEYS.map(key => localStorage.getItem(key)).find(Boolean);
        const saved = JSON.parse(current || legacy || "null");
        if (saved) { myStoneIds = Array.isArray(saved.myStoneIds) ? [...new Set(saved.myStoneIds.filter(id => STONES.some(stone => stone.id === id)))] : []; const restored = restoreComposition(saved); sizeEditMode = restored.snapshot.editor.sizeEditMode; sizeEditValue = restored.snapshot.editor.sizeEditValue; orderForm.notes = restored.snapshot.customerNote; notice = restored.migrated ? 'Votre création complète a été retrouvée et mise à jour.' : saved.cylinderSlot !== 0 || saved.spacerQuantity !== 1 ? 'Votre création a été retrouvée. L’intercalaire signature est maintenant obligatoire et placé au début du montage.' : 'Votre création a été retrouvée.'; if (saved.spacerQuantity === undefined) { history.push(historyEntry()); state.spacerQuantity = 1; rebalanceBeadsToLength(); state.cylinderSlot = Math.min(state.cylinderSlot, state.beads.length); state.selectedBeadIndex = Math.min(state.selectedBeadIndex, state.beads.length - 1); notice = 'Intercalaire signature 6 mm ajouté : la longueur tient maintenant compte de ses 5 mm. Vérifiez votre composition.'; } if (!current) localStorage.setItem(STORAGE_KEY, JSON.stringify(draftSnapshot())); }
      } catch (error) { restoreBlocked = true; notice = 'Votre sauvegarde ne peut pas être restaurée. Elle est conservée. Choisissez Recommencer pour créer un nouveau bracelet.'; console.warn('ZenEncens restore failed', error); }
    }

    const normalizeSearch = (value) => value.toLocaleLowerCase("fr").replace(/œ/g, 'oe').normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    const estimatedCountFromBase = () => Math.max(1, Math.round((getSize() * 10) / state.baseBeadSizeMm));
    const defaultBead = () => ({ stoneName: "Quartz rose", sizeMm: state.baseBeadSizeMm });
    const targetStoneLengthMm = () => Math.max(state.baseBeadSizeMm, Math.round(getSize() * 10));
    const stoneLengthMm = () => state.beads.reduce((sum, bead) => sum + bead.sizeMm, 0);

    function rebalanceBeadsToLength() {
      state.beads = ZenCore.rebalance(state.beads, getSize(), state.baseBeadSizeMm, state.selectedBeadIndex, ZenCore.spacerLength(state));
    }

    function syncBeads() {
      state.beads = state.beads
        .filter((bead) => bead && typeof bead === "object")
        .map((bead) => ({
          stoneName: bead.stoneName || "Quartz rose", empty: !!bead.empty,
          sizeMm: BEAD_SIZES.includes(bead.sizeMm) ? bead.sizeMm : state.baseBeadSizeMm
        }));

      rebalanceBeadsToLength();

      if (state.selectedBeadIndex >= state.beads.length) state.selectedBeadIndex = Math.max(0, state.beads.length - 1);
      state.selectedApplySizeMm = state.beads[state.selectedBeadIndex].sizeMm;
      const totalSlots = state.beads.length + 1;
      state.cylinderSlot = 0; state.spacerQuantity = 1;
    }

    const totalLengthMm = () => stoneLengthMm() + ZenCore.spacerLength(state);

    function sizeMixLabel() {
      const mix = { 10: 0, 8: 0, 6: 0, 4: 0 };
      state.beads.forEach((bead) => { mix[bead.sizeMm] += 1; });
      return `${mix[10]}x10mm / ${mix[8]}x8mm / ${mix[6]}x6mm / ${mix[4]}x4mm`;
    }



    function swatch(stone) {
      const texture = stoneTexture(stone.name);
      if (texture) return `center/cover no-repeat url('${texture}')`;
      const [a,b,c] = stone.palette;
      if (stone.pattern === "banded") return `linear-gradient(135deg, ${a}, ${b} 45%, ${c} 70%, ${b})`;
      if (stone.pattern === "speckled") return `radial-gradient(circle at 30% 30%, ${c}, ${a} 45%, ${b})`;
      if (stone.pattern === "eye") return `linear-gradient(135deg, ${c}, ${a} 40%, ${b} 60%, ${c})`;
      if (stone.pattern === "lava") return `radial-gradient(circle at 40% 35%, ${b}, ${a} 60%, ${c})`;
      if (stone.pattern === "veined") return `linear-gradient(135deg, ${a}, ${c} 30%, ${a} 55%, ${b})`;
      if (stone.pattern === "moss") return `linear-gradient(135deg, ${c}, ${a} 35%, ${b} 78%)`;
      return `radial-gradient(circle at 30% 30%, ${c}, ${a} 45%, ${b})`;
    }
    function renderBuilder() {
      ui.builder.innerHTML = `
        <div class="section">
          <h2>Longueur du bracelet</h2>
          <p class="help">Choisissez la longueur de votre bracelet.</p>
          <p class="help wrist-size-guidance"><strong>Choisissez 1 cm de plus que votre tour de poignet mesuré.</strong><br>Exemple : 15 cm mesurés → choisissez 16 cm.</p><div class="row" id="sizeRow"></div><details class="measure-help"><summary>Comment mesurer mon poignet ?</summary><p>Entourez votre poignet d’un mètre souple, sans serrer. La taille choisie ici est la longueur cible du bracelet ; aucune marge n’est ajoutée automatiquement.</p></details>
        </div>
        <div class="section">
          <h2>Diamètre de départ</h2>
          <p class="help">Taille de départ. Vous pourrez ensuite les mélanger.</p>
          <div class="row" id="beadRow"></div>
        </div>
        <div class="section">
          <h2>Les pierres</h2>
          <p class="help">Ajoutez vos pierres à « Mes perles », puis composez votre bracelet.</p>
          <div class="catalog-tools"><div class="search-wrap"><input class="stone-search" id="stoneSearch" type="search" placeholder="Rechercher une pierre…" autocomplete="off" aria-label="Rechercher une pierre" /></div><span class="catalog-count" id="catalogCount"></span></div>
          <div class="catalog" id="catalog"></div>
        </div>`;

      const sizeRow = ui.builder.querySelector("#sizeRow");
      PRESET_SIZES.forEach((size) => {
        const b = document.createElement("button");
        b.type = "button";
        b.className = `selector-btn${state.braceletSizeCm === size ? " active" : ""}`;
        b.id = 'bracelet-size-' + size;
        b.textContent = `${size} cm`;
        b.setAttribute("aria-pressed", String(state.braceletSizeCm === size));
        b.addEventListener("click", () => changeSizing(size, state.baseBeadSizeMm));
        sizeRow.appendChild(b);
      });

      const beadRow = ui.builder.querySelector("#beadRow");
      BEAD_SIZES.forEach((size) => {
        const b = document.createElement("button");
        b.type = "button";
        b.className = `selector-btn${state.baseBeadSizeMm === size ? " active" : ""}`;
        b.id = 'bead-size-' + size;
        b.textContent = `${size} mm`;
        b.setAttribute('aria-pressed', String(state.baseBeadSizeMm === size));
        b.innerHTML = '<span class="size-dot" style="width:' + (size * 2) + 'px;height:' + (size * 2) + 'px"></span>' + size + ' mm';
        b.addEventListener('click', () => changeSizing(state.braceletSizeCm, size));
        beadRow.appendChild(b);
      });

      const catalog = ui.builder.querySelector("#catalog");
      const searchInput = ui.builder.querySelector("#stoneSearch");
      const catalogCount = ui.builder.querySelector("#catalogCount");
      searchInput.value = catalogQuery;
      const renderCatalog = () => {
        const query = normalizeSearch(catalogQuery.trim());
        const visibleStones = query ? STONES.filter((stone) => normalizeSearch(`${stone.name} ${stone.displayName || ""} ${stone.virtues || ""} ${stone.chakra || ""} ${stone.vibe || ""}`).includes(query)) : STONES;
        catalog.innerHTML = "";
        catalogCount.textContent = `${visibleStones.length} pierre${visibleStones.length > 1 ? "s" : ""}`;
        if (!visibleStones.length) {
          catalog.innerHTML = `<div class="catalog-empty">Aucune pierre trouvée.<br><small>Essayez le nom d’une pierre.</small></div>`;
          return;
        }
        visibleStones.forEach((stone) => {
          const el = document.createElement("div");

          el.id = 'stone-' + ZenCore.stoneId(stone.name);
          el.className = "stone stone-static";
          const compactName = ['amethyste', 'amazonite'].includes(stone.id) ? ' stone-name-compact' : '';
          el.innerHTML = `<div class="stone-row"><img class="swatch" src="${stoneTexture(stone.name)}" alt="" loading="lazy" decoding="async" width="38" height="38"><div class="stone-head"><span class="stone-name${compactName}">${stoneLabel(stone)}</span><span class="stone-price">${formatEuro(getStonePrice(stone.name, state.selectedApplySizeMm))}</span></div></div>`;
          const unavailable = !available(stone.name, state.selectedApplySizeMm);
          if (unavailable) el.querySelector('.stone-price').textContent = 'Indisponible';
          const card = document.createElement('div'); card.className = 'stone-choice';
          const save = document.createElement('button'); save.type = 'button'; save.className = 'ghost shortlist-add'; save.id = 'save-stone-' + stone.id;
          const saved = myStoneIds.includes(stone.id);
          save.textContent = saved ? '✓ Dans mes perles' : '+ Ajouter à mes perles';
          save.setAttribute('aria-label', (saved ? 'Retirer ' : 'Ajouter ') + stoneLabel(stone) + (saved ? ' de mes perles' : ' à mes perles'));
          save.setAttribute('aria-pressed', String(saved));
          save.onclick = () => { myStoneIds = saved ? myStoneIds.filter(id => id !== stone.id) : [...myStoneIds, stone.id]; render(); announce(stoneLabel(stone) + (saved ? ' retirée de mes perles.' : ' ajoutée à mes perles.')); };
          const zoom = document.createElement('button'); zoom.type = 'button'; zoom.className = 'ghost stone-zoom';
          zoom.setAttribute('aria-label', 'Agrandir la texture : ' + stoneLabel(stone)); zoom.setAttribute('aria-haspopup', 'dialog');
          zoom.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M7 10h6M10 7v6"/></svg>';
          zoom.onclick = () => showStoneTexture(stone, zoom);
          const actions = document.createElement('div'); actions.className = 'stone-actions'; actions.append(save, zoom);
          card.append(el, actions); catalog.appendChild(card);
        });
      };
      searchInput.addEventListener("input", () => { catalogQuery = searchInput.value; renderCatalog(); });
      renderCatalog();
    }

    function showStoneTexture(stone, trigger) {
      const dialog = document.createElement('dialog'); dialog.className = 'stone-texture-dialog';
      dialog.setAttribute('aria-label', 'Texture de la pierre : ' + stoneLabel(stone));
      const close = document.createElement('button'); close.type = 'button'; close.className = 'ghost'; close.textContent = 'Fermer'; close.autofocus = true;
      const title = document.createElement('h2'); title.textContent = stoneLabel(stone);
      const image = document.createElement('img'); image.src = stoneTexture(stone.name); image.alt = 'Texture agrandie : ' + stoneLabel(stone);
      const details = document.createElement('dl'); details.className = 'stone-associations';
      const virtueLabel = document.createElement('dt'); virtueLabel.textContent = 'Vertu associée';
      const virtue = document.createElement('dd'); virtue.textContent = stone.associatedVirtue;
      const signsLabel = document.createElement('dt'); signsLabel.textContent = 'Signes associés';
      const signs = document.createElement('dd'); signs.textContent = stone.associatedSigns.join(' · ');
      details.append(virtueLabel, virtue, signsLabel, signs);
      if (stone.associationReview) {
        const review = document.createElement('p'); review.className = 'association-review'; review.textContent = 'Association zodiacale à confirmer.';
        details.append(review);
      }
      const imageNote = document.createElement('p'); imageNote.className = 'texture-note'; imageNote.textContent = 'Aperçu indicatif : chaque perle naturelle possède ses propres nuances.';
      const disclaimer = document.createElement('p'); disclaimer.className = 'association-disclaimer'; disclaimer.textContent = 'Associations traditionnelles, sans effet médical prouvé.';
      close.onclick = () => dialog.close();
      dialog.addEventListener('click', event => { if (event.target !== dialog) return; const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); });
      dialog.addEventListener('close', () => { dialog.remove(); if (trigger.isConnected) trigger.focus({preventScroll:true}); }, {once:true});
      dialog.append(close, title, image, details, imageNote, disclaimer); ZEN_ROOT.append(dialog); dialog.showModal();
    }

    function renderPreview() {
      const priorShell = ui.preview.querySelector('#viewerShell');
      const viewerKey = JSON.stringify([state.beads, state.cylinderSlot, state.selectedBeadIndex, state.baseBeadSizeMm, state.spacerSizeMm, state.spacerQuantity]);
      const reuseViewer = priorShell && premiumViewerUpdate;
      const selectedBead = state.beads[state.selectedBeadIndex] || defaultBead();
      const targetLength = getSize() * 10;
      const currentLength = totalLengthMm();
      const selectedBeadPrice = getStonePrice(selectedBead.stoneName, selectedBead.sizeMm);

      ui.preview.innerHTML = `
        <div class="section">
          <h2>Votre bracelet</h2>
          <p class="help">Glissez pour le tourner. Touchez une perle pour la modifier.</p>
          <div class="history-bar"><button class="ghost" id="undoChange" type="button" ${history.length ? "" : "disabled"}>↶ Annuler</button><button class="ghost" id="redoChange" type="button" ${future.length ? "" : "disabled"}>↷ Rétablir</button></div>
          <div class="design-tools"><div class="size-edit-tools${sizeEditMode ? ' is-active' : ''}"><h3>Taille des perles</h3><div class="row" id="applySizeRow" aria-label="Diamètre à appliquer"></div><p id="sizeModeHelp">Choisissez un diamètre, puis touchez les perles à modifier.</p><p>${sizeEditMode ? sizeEditValue + ' mm · Touchez plusieurs perles, puis Terminer.' : 'La pierre et sa couleur restent identiques.'}</p><button type="button" id="sizeMode" class="ghost" ${sizeEditMode ? '' : 'hidden'}>Terminer</button></div><section class="my-stones" aria-labelledby="myStonesTitle"><h3 id="myStonesTitle">Mes perles</h3><p class="help">Gardez vos pierres préférées à portée de main.</p><div id="myStonesList"></div><button class="ghost inspire-shortlist" id="inspireMe" type="button" ${myStoneIds.length ? "" : "disabled"}>✦ M’inspirer avec mes perles</button></section></div>
          <div class="preview-shell" id="viewerShell">
            <div class="viewer-glow"></div>
            <canvas id="braceletCanvas" aria-label="Aperçu interactif du bracelet en 3D"></canvas>
            <button class="ghost viewer-reset" id="viewerReset" type="button" aria-label="Recommencer mon bracelet" title="Recommencer mon bracelet" aria-haspopup="dialog"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 8a8 8 0 0 0-14-3L3 8m0-5v5h5M4 16a8 8 0 0 0 14 3l3-3m0 5v-5h-5"/></svg></button>
            <div class="material-note">Aperçu indicatif · Chaque perle naturelle est unique</div>
            <div class="viewer-loading" id="viewerLoading">Textures minérales</div>
            <div class="viewer-hint">Glissez pour tourner · pincez pour zoomer</div>

          </div>
          <div class="selected-meta">Position ${state.selectedBeadIndex+2} · ${selectedBead.sizeMm} mm · ${selectedBead.empty ? 'À compléter' : stoneLabel(getStone(selectedBead.stoneName)) + ' · ' + formatEuro(selectedBeadPrice)}</div>
          <div class="apply-tools">
            <button class="ghost" id="applyStoneAll" type="button">Tout dans cette pierre</button>
            <button class="ghost" id="resetBracelet" type="button">Recommencer</button>
            <div id="signatureControls"><h3>Intercalaire signature Zenencens</h3><p>Acier inoxydable · hauteur 5 mm · ${state.spacerQuantity ? 'quantité 1 · position ' + (state.cylinderSlot + 1) : 'sans intercalaire'}</p>
            <div class="row">${[6,8].map(size => `<button type="button" class="selector-btn${state.spacerQuantity === 1 && state.spacerSizeMm === size ? ' active' : ''}" data-signature-size="${size}" aria-pressed="${state.spacerQuantity === 1 && state.spacerSizeMm === size}">${size} mm</button>`).join('')}</div>
            </div>
          </div>
          <div class="stats"><div class="stat"><div class="stat-k">Bracelet</div><div class="stat-v">${getSize()} cm</div></div><div class="stat"><div class="stat-k">Perles</div><div class="stat-v">${state.beads.length}</div></div><div class="stat"><div class="stat-k">Tailles</div><div class="stat-v">${sizeMixLabel()}</div></div></div>
          <div class="trust-note">Intercalaire signature ${state.spacerQuantity ? state.spacerSizeMm + ' mm inclus' : 'retiré'} · Ajustement ${(targetLength-currentLength).toFixed(1)} mm</div>
        </div>`;

      const viewerShell = ui.preview.querySelector("#viewerShell");
      if (reuseViewer) { viewerShell.replaceWith(priorShell); if (priorShell.dataset.viewerKey !== viewerKey) { priorShell.dataset.viewerKey = viewerKey; premiumViewerUpdate(); } }
      else { viewerShell.dataset.viewerKey = viewerKey; initPremiumViewer(viewerShell); }
      const applySizeRow = ui.preview.querySelector("#applySizeRow");
      [4, 6, 8, 10].forEach((size) => {
        const b = document.createElement("button");
        b.type = "button";
        b.className = `selector-btn${sizeEditMode && sizeEditValue === size ? " active" : ""}`;
        b.id = 'apply-size-' + size;
        b.setAttribute('aria-pressed', String(sizeEditMode && sizeEditValue === size));
        b.textContent = `${size} mm`;
        b.addEventListener('click', () => { sizeEditValue = size; sizeEditMode = true; render(); });
        applySizeRow.appendChild(b);
      });
      ui.preview.querySelector('#sizeMode').onclick = () => { sizeEditMode = false; render(); };
      const shortlist = ui.preview.querySelector('#myStonesList');
      if (!myStoneIds.length) { const hint = document.createElement('p'); hint.className = 'help'; hint.textContent = 'Touchez « Ajouter à mes perles » sous les pierres du catalogue.'; shortlist.append(hint); }
      myStoneIds.forEach(id => {
        const stone = STONES.find(s => s.id === id); if (!stone) return;
        const button = document.createElement('button'); button.type = 'button'; button.className = 'ghost my-stone'; button.id = 'my-stone-' + id;
        button.setAttribute('aria-pressed', String(state.selectedStoneName === stone.name));
        const image = document.createElement('img'); image.src = stoneTexture(stone.name); image.alt = ''; image.width = 28; image.height = 28; image.loading = 'lazy';
        button.setAttribute('aria-label', stoneLabel(stone)); button.title = stoneLabel(stone); button.append(image);
        button.onclick = () => { state.selectedStoneName = stone.name; render(); announce(stoneLabel(stone) + (sizeEditMode ? ' sélectionnée. Touchez Terminer pour changer de pierre.' : ' sélectionnée. Touchez une perle du bracelet pour y placer cette pierre.')); };
        shortlist.append(button);
      });
      ui.preview.querySelector("#undoChange").addEventListener("click", undoComposition);
      ui.preview.querySelector("#redoChange").addEventListener("click", redoComposition);
      ui.preview.querySelector('#inspireMe').onclick = () => {
        const palette = myStoneIds.map(id => STONES.find(stone => stone.id === id)).filter(Boolean).map(stone => stone.name);
        const choices = state.beads.map(bead => palette.filter(name => available(name, bead.sizeMm)));
        if (!palette.length || choices.some(names => !names.length)) return announce('Vos pierres ne sont pas disponibles pour toutes les tailles du bracelet. Modifiez votre sélection.');
        // Shuffle a repeating palette, preserving every position and diameter.
        const shuffled = [...palette];
        for (let i = shuffled.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]; }
        let names = state.beads.map((bead, index) => choices[index].includes(shuffled[index % shuffled.length]) ? shuffled[index % shuffled.length] : choices[index][Math.floor(Math.random() * choices[index].length)]);
        if (names.every((name, index) => name === state.beads[index].stoneName && !state.beads[index].empty)) {
          const index = choices.findIndex(options => options.length > 1);
          if (index < 0) return announce('Ajoutez une autre pierre à « Mes perles » pour varier les compositions.');
          names[index] = choices[index].find(name => name !== names[index]);
        }
        mutateComposition(() => { state.beads = state.beads.map((bead, index) => ({ ...bead, stoneName: names[index], empty: false })); });
        announce('Nouvelle composition avec vos perles. Touchez à nouveau pour varier, ou Annuler pour revenir.');
      };
      ui.preview.querySelector("#applyStoneAll").addEventListener("click", () => mutateComposition(() => { state.beads = state.beads.map((bead) => ({ ...bead, stoneName: state.selectedStoneName, empty: false })); }));
      const requestReset = () => confirmAction('Recommencer votre bracelet ?', 'Votre bracelet sera remplacé par une base en quartz rose. Vous pourrez annuler cette action.', () => { restoreBlocked = false; mutateComposition(() => { state.beads = []; state.selectedBeadIndex = 0; state.cylinderSlot = 0; }); });
      ui.preview.querySelector('#resetBracelet').onclick = requestReset;
      ui.preview.querySelector('#viewerReset').onclick = requestReset;
      ui.preview.querySelectorAll('[data-signature-size]').forEach(button => button.addEventListener('click', () => mutateComposition(() => { state.spacerSizeMm = Number(button.dataset.signatureSize); state.spacerQuantity = 1; })));
    }
    function summary(name="", contact="", notes="") {
      const stoneCounts = {};
      const sizeCounts = {10:0,8:0,6:0,4:0};
      const totalPriceValue = totalPrice();

      state.beads.forEach((bead) => {
        if (bead.empty) return;
        stoneCounts[bead.stoneName] = (stoneCounts[bead.stoneName] || 0) + 1;
        sizeCounts[bead.sizeMm] += 1;
      });

      return [
        "DEMANDE BRACELET ZENENCENS",
        "",
        `Nom: ${name || "-"}`,
        `Contact: ${contact || "-"}`,
        `Taille bracelet cible: ${getSize()} cm`,
        `Taille perle de base (auto): ${state.baseBeadSizeMm} mm`,
        `Perles choisies: ${state.beads.filter(b => !b.empty).length} / ${state.beads.length} emplacements`,
        `Prix estimé: ${formatEuro(totalPriceValue)}`,
        `Intercalaire signature Zenencens : diamètre ${state.spacerSizeMm} mm, hauteur 5 mm, quantité ${state.spacerQuantity}, position ${state.spacerQuantity ? state.cylinderSlot + 1 : "aucune"}`,
        `Mix tailles: 10mm x${sizeCounts[10]} | 8mm x${sizeCounts[8]} | 6mm x${sizeCounts[6]} | 4mm x${sizeCounts[4]}`,
        `Longueur estimée: ${(totalLengthMm()/10).toFixed(1)} cm`,
        `Composition pierres: ${Object.entries(stoneCounts).map(([k,v])=>`${k} x${v}`).join(" | ") || "-"}`,`Détail tarifaire: ${state.beads.map((bead)=>`${bead.stoneName} ${bead.sizeMm}mm ${formatEuro(getStonePrice(bead.stoneName, bead.sizeMm))}`).join(" | ") || "-"}`,
        `Ordre exact (hors intercalaire signature): ${state.beads.map((bead)=>`${bead.empty ? 'À COMPLÉTER' : bead.stoneName}(${bead.sizeMm}mm)`).join(" / ")}`,
        `Notes: ${notes || "-"}`
      ].join("\n");
    }


    function createLocalPreviewPayload(summaryText) {
      if (!LOCAL_PREVIEW) throw new Error('Unsigned designs are restricted to local preview.');
      const design = ZenCore.design(state, PRICE_LIST, crypto.randomUUID(), orderForm.notes, ZEN_CONFIG.inventory, Object.fromEntries(STONES.map(stone => [stone.name, stone.id])));
      return { design, properties: { ...ZenCore.properties(design, summaryText), _zen_preview: 'local-only' } };
    }

    async function findCartDesign(id, priceCents, attempts = 3) {
      const root = window.Shopify?.routes?.root || '/';
      for (let attempt = 0; attempt < attempts; attempt++) {
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Impossible de confirmer le panier. Votre création est conservée. Réessayez dans un instant.');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('La réponse du panier est incomplète. Votre création est conservée.');
        const item = cart.items.find(line => line.properties?._zen_design_id === id);
        if (item) {
          if (Number(item.price) !== priceCents || !Number.isInteger(item.quantity) || item.quantity < 1) throw new Error('Le prix ou la quantité doit être vérifié dans votre panier avant de poursuivre.');
          return item;
        }
        if (attempt + 1 < attempts) await new Promise(resolve => setTimeout(resolve, 250 * (attempt + 1)));
      }
      return null;
    }

    function completeCartAdd(item, recovered = false) {
      clearPendingAdd();
      track('custom_bracelet_added_to_cart');
      ZEN_ROOT.dispatchEvent(new CustomEvent('zenencens:cart-added', { bubbles: true, detail: { item } }));
      return { recovered };
    }

    async function readShopifyVariant(root, variantId) {
      // Newly created price variants can briefly return 404 at the storefront.
      // Retry reads only; never repeat an uncertain cart POST.
      for (let attempt = 0; attempt < 6; attempt++) {
        const url = root + 'variants/' + variantId + '.js' + (attempt ? '?zen_retry=' + attempt : '');
        const response = await fetch(url, { cache: 'no-store', signal: AbortSignal.timeout(15000) });
        if (response.ok) return response.json();
        if (response.status !== 404 || attempt === 5) break;
        await new Promise(resolve => setTimeout(resolve, Math.min(400 * 2 ** attempt, 4000)));
      }
      throw new Error('Le tarif de votre création n’est pas encore disponible. Votre bracelet est conservé. Réessayez dans un instant.');
    }

    async function addShopifyCartItem(summaryText) {
      if (restoreBlocked || !inventoryValid()) throw new Error('Vérifiez les pierres de votre composition.');
      if (!SHOPIFY_PRODUCT.variantId || !SHOPIFY_PRODUCT.cartAddUrl) throw new Error('Le panier sera disponible sur la boutique. Votre création est conservée.');
      if (!SHOPIFY_PRODUCT.quoteUrl && !LOCAL_PREVIEW) throw new Error('La vérification sécurisée de votre bracelet est indisponible. Votre création est conservée.');
      const root = window.Shopify?.routes?.root || '/';
      if (pendingAdd) {
        const found = await findCartDesign(pendingAdd, pendingPrice);
        if (found) return completeCartAdd(found, true);
        // A confirmed-absent old attempt must not consume this explicit add click.
        clearPendingAdd();
      }
      let quote = null;
      if (SHOPIFY_PRODUCT.quoteUrl) {
        const response = await fetch(SHOPIFY_PRODUCT.quoteUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ configuration: compositionSnapshot(), note: orderForm.notes }), signal: AbortSignal.timeout(20000) });
        const result = await response.json();
        if (!response.ok) { if (result.inventory) ZEN_CONFIG.inventory = result.inventory; throw new Error(result.error || 'Impossible de vérifier votre création.'); }
        if (!result.properties || !/^[a-f0-9]{64}$/.test(result.properties._zen_signature || '')) throw new Error('La vérification sécurisée de votre bracelet est incomplète. Votre création est conservée.');
        if (result.priceCents !== ZenCore.priceCents(state.beads, PRICE_LIST) || result.currency !== 'EUR' || !/^\d+$/.test(String(result.variantId))) throw new Error('Le tarif a changé. Contactez la boutique avant de poursuivre.');
        quote = result;
      }
      const variantId = quote?.variantId || SHOPIFY_PRODUCT.variantId;
      const variant = await readShopifyVariant(root, variantId);
      if (!variant.available) throw new Error('Ce bracelet est momentanément indisponible. Votre création est conservée.');
      if (SHOPIFY_PRODUCT.currency !== 'EUR' || Number(variant.price) !== ZenCore.priceCents(state.beads, PRICE_LIST)) throw new Error('Le tarif de cette création doit être confirmé par la boutique avant l’ajout au panier. Votre création est conservée.');
      const preview = quote ? null : createLocalPreviewPayload(summaryText);
      const d = quote ? ZenCore.decode(quote.properties, PRICE_LIST) : preview.design;
      const payload = { id: variantId, quantity: 1, properties: quote?.properties || preview.properties };
      pendingAdd = d.id;
      pendingPrice = d.priceCents;
      try { sessionStorage.setItem('zenencens-pending-cart', JSON.stringify({ id: pendingAdd, priceCents: pendingPrice })); } catch { /* Reconciliation still works until this tab closes. */ }
      let response;
      try {
        response = await fetch(SHOPIFY_PRODUCT.cartAddUrl.replace(/\.js$/, '') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload), signal: AbortSignal.timeout(20000)
        });
      } catch (error) {
        // POST may have succeeded before connection loss. Never automatically repeat it.
        const recovered = await findCartDesign(d.id, d.priceCents);
        if (recovered) return completeCartAdd(recovered);
        throw new Error('La confirmation du panier n’est pas arrivée. Vérifiez votre panier avant de réessayer pour éviter un doublon.');
      }
      if (!response.ok) { if (response.status < 500) clearPendingAdd(); throw new Error('Le panier n’a pas confirmé cet ajout. Vérifiez votre panier avant de réessayer.'); }
      const item = await response.json();
      if (item.properties?._zen_design_id !== d.id || Number(item.price) !== d.priceCents) throw new Error('Le panier doit être vérifié avant de poursuivre. Contactez la boutique si le montant diffère.');
      const confirmed = await findCartDesign(d.id, d.priceCents);
      if (!confirmed) throw new Error('Votre bracelet n’est pas encore confirmé dans le panier. Votre création est conservée ; réessayez dans un instant.');
      return completeCartAdd(confirmed);
    }

    function renderProject() {
      const empty = state.beads.filter(b => b.empty).length;
      const valid = !empty && !restoreBlocked && inventoryValid() && ZenCore.valid(compositionSnapshot(), STONES.map(s => s.name));
      ui.project.innerHTML = `<div class="section"><span class="selection-eyebrow">Votre création, en détail</span><h2>Un bracelet qui vous ressemble</h2>
        <div class="project-price"><div class="project-price-k">Total de votre création</div><div class="project-price-v">${formatEuro(totalPrice())}</div><div class="project-sub">${getSize()} cm · ${state.beads.length} perles · ${state.spacerQuantity ? 'intercalaire signature ' + state.spacerSizeMm + ' mm' : 'sans intercalaire'}</div></div>
        <p class="help">${empty ? empty + ' emplacement(s) à compléter' : lengthGuidance()}</p>
        <div class="field"><label for="notes">Une attention particulière ? <small>(facultatif)</small></label><textarea id="notes" maxlength="500" placeholder="Un cadeau, une précision pour l’atelier…"></textarea></div>
        <button class="primary-btn review-button" id="openReview" ${valid ? '' : 'disabled'}>Vérifier mon bracelet</button>
        <div id="reviewContent" ${reviewed ? '' : 'hidden'}><h3>Prêt à être créé pour vous</h3><p>Vérifiez l’ordre des pierres ci-dessous. Les nuances naturelles peuvent varier.</p><div class="review-sequence"></div><p id="reviewMix"></p>
        <button class="ghost" id="editDesign">Modifier mon bracelet</button><button class="primary-btn review-button" id="prepareOrder" ${valid && !cartBusy ? '' : 'disabled'}>${cartBusy ? 'Ajout en cours…' : 'Ajouter mon bracelet au panier'}</button></div>
        <p class="cta-note" id="ctaNote" role="status"></p><a class="cart-link" hidden>Voir mon panier</a>
        <details class="order-details"><summary>Conserver le détail de ma création</summary><textarea id="draft" class="draft" readonly aria-label="Résumé de votre création"></textarea><button class="ghost" id="copySummary">Copier le résumé</button></details></div>`;
      const notes = ui.project.querySelector('#notes'); notes.value = orderForm.notes;
      const draft = ui.project.querySelector('#draft'); draft.value = summary('', '', orderForm.notes);
      notes.addEventListener('input', () => { orderForm.notes = notes.value; draft.value = summary('', '', notes.value); persistDraft(); });
      const ctaNote = ui.project.querySelector('#ctaNote'); ctaNote.textContent = cartResult;
      const cartLink = ui.project.querySelector('.cart-link'); cartLink.href = SHOPIFY_PRODUCT.cartUrl || '/cart'; cartLink.hidden = !cartConfirmed || cartBusy || !SHOPIFY_PRODUCT.variantId;
      ui.project.querySelector('#openReview').onclick = () => { reviewed = true; activeStep = 4; track('review_opened'); renderProject(); renderNavigation(); ui.project.querySelector('#reviewContent').scrollIntoView({ block: 'start' }); };
      ui.project.querySelector('#editDesign').onclick = () => { reviewed = false; activeStep = 3; renderProject(); renderNavigation(); ui.preview.scrollIntoView({ block: 'start' }); };
      const sequence = ui.project.querySelector('.review-sequence'); appendSequence(sequence, false);
      ui.project.querySelector('#reviewMix').textContent = groupedMaterials();
      ui.project.querySelector('#copySummary').onclick = async () => { try { await navigator.clipboard.writeText(draft.value); ctaNote.textContent = 'Résumé copié.'; } catch { draft.parentElement.open = true; draft.focus(); draft.select(); ctaNote.textContent = 'Sélectionnez et copiez le résumé affiché.'; } };
      ui.project.querySelector('#prepareOrder').onclick = async () => {
        if (cartBusy || !reviewed) return;
        cartBusy = true; cartConfirmed = false; cartResult = ''; renderProject(); ZEN_ROOT.setAttribute('aria-busy', 'true');
        ui.builder.inert = true; ui.preview.inert = true; ui.project.querySelector('#notes').disabled = true;
        try { const added = await addShopifyCartItem(summary('', '', orderForm.notes)); cartConfirmed = true; cartResult = added?.recovered ? 'Votre précédent ajout est bien présent dans le panier. Aucun doublon n’a été créé.' : 'Votre bracelet a été ajouté au panier.'; reviewed = false; }
        catch (error) { console.warn('ZenEncens cart:', error); cartResult = error.name === 'Error' ? error.message : 'L’ajout au panier n’a pas pu être confirmé. Vérifiez la connexion et votre panier. Votre création est conservée.'; }
        finally { cartBusy = false; ui.builder.inert = false; ui.preview.inert = false; ZEN_ROOT.removeAttribute('aria-busy'); render(); }
      };
      ui.project.querySelectorAll('button').forEach(button => { button.type = 'button'; });
    }

    function groupedMaterials() {
      const counts = new Map();
      state.beads.filter(b => !b.empty).forEach(b => { const key = stoneLabel(getStone(b.stoneName)) + ' · ' + b.sizeMm + ' mm'; counts.set(key, (counts.get(key) || 0) + 1); });
      return [...counts].map(([name, count]) => name + ' × ' + count).join(' / ');
    }

    function appendSequence(container, editable) {
      state.beads.forEach((bead, index) => {
        if (state.spacerQuantity && index === state.cylinderSlot) spacer();
        const cell = document.createElement(editable ? 'button' : 'div'); cell.className = 'sequence-bead' + (editable && index === state.selectedBeadIndex ? ' active' : '');
        const image = document.createElement('img'); image.src = stoneTexture(bead.stoneName); image.alt = ''; image.loading = 'lazy'; image.width = 40; image.height = 40;
        if (bead.empty) { image.style.opacity = '0.15'; }
        const text = document.createElement('span'); text.textContent = (index + 2) + '. ' + (bead.empty ? 'À compléter' : stoneLabel(getStone(bead.stoneName))) + ' · ' + bead.sizeMm + ' mm';
        cell.append(image, text);
        if (editable) { cell.type = 'button'; cell.id = 'sequence-position-' + index; cell.setAttribute('aria-pressed', String(index === state.selectedBeadIndex)); cell.onclick = () => { if (sizeEditMode) { resizeTarget(index); return; } activeStep = 3; state.selectedBeadIndex = index; state.selectedApplySizeMm = bead.sizeMm; render(); announce('Position ' + (index + 2) + ' sélectionnée.'); }; }
        container.append(cell);
      });
      if (state.spacerQuantity && state.cylinderSlot === state.beads.length) spacer();
      function spacer() { const mark = document.createElement('button'); mark.type = 'button'; mark.className = 'sequence-spacer'; mark.textContent = 'Intercalaire signature Zenencens · ' + state.spacerSizeMm + ' mm · position ' + (state.cylinderSlot + 1); mark.onclick = () => { if (sizeEditMode) { resizeTarget('signature'); return; } ui.preview.querySelector('#signatureControls').scrollIntoView({block:'center'}); ui.preview.querySelector('[data-signature-size]').focus(); }; container.append(mark); }
    }

    function renderNavigation() {
      ZEN_ROOT.querySelector('.studio-nav')?.remove();
    }

    function renderStudio() {
      renderNavigation();
      ZEN_ROOT.querySelector('#headerReset')?.remove();
      let status = ZEN_ROOT.querySelector('#studioNotice');
      if (!status) { status = document.createElement('p'); status.id = 'studioNotice'; status.className = 'studio-notice'; status.setAttribute('role', 'status'); ZEN_ROOT.querySelector('.topbar').after(status); }
      status.textContent = notice || 'Une base en quartz rose est prête. Personnalisez chaque perle à votre rythme.';
      const save = document.createElement('p'); save.className = 'save-status'; save.textContent = saveMessage; ui.project.append(save);
      const editor = document.createElement('div'); editor.className = 'section sequence-editor';
      editor.innerHTML = '<h3>L’ordre de vos perles</h3><p class="help">Choisissez une position, puis appliquez la pierre sélectionnée.</p><div class="sequence-tools"><button class="primary-btn" id="placeStone">Ajouter la pierre sélectionnée</button><button class="ghost" id="moveLeft">← Déplacer</button><button class="ghost" id="moveRight">Déplacer →</button><button class="ghost" id="removeBead">Retirer cette pierre</button></div><div class="bead-sequence"></div>';
      appendSequence(editor.querySelector('.bead-sequence'), true); ui.preview.append(editor);
      editor.querySelector('#placeStone').onclick = () => {
        activeStep = 3;
        let i = state.beads.findIndex(b => b.empty); if (i < 0) i = state.selectedBeadIndex;
        const size = state.sizeBrushArmed ? state.selectedApplySizeMm : state.beads[i].sizeMm;
        if (!available(state.selectedStoneName, size)) return announce('Cette pierre est indisponible dans ce diamètre.');
        mutateComposition(() => { state.beads[i].stoneName = state.selectedStoneName; state.beads[i].sizeMm = size; state.beads[i].empty = false; state.sizeBrushArmed = false; state.selectedBeadIndex = Math.min(i + 1, state.beads.length - 1); state.selectedApplySizeMm = state.beads[state.selectedBeadIndex].sizeMm; });
        announce(state.selectedStoneName + ' ajoutée en position ' + (i + 2) + '.');
      };
      editor.querySelector('#removeBead').onclick = () => { mutateComposition(() => { state.beads[state.selectedBeadIndex].empty = true; }); announce('Pierre retirée. Complétez cet emplacement ou annulez.'); };
      for (const [id, step] of [['moveLeft', -1], ['moveRight', 1]]) {
        const b = editor.querySelector('#' + id); b.disabled = state.selectedBeadIndex + step < 0 || state.selectedBeadIndex + step >= state.beads.length;
        b.onclick = () => mutateComposition(() => { const i = state.selectedBeadIndex, j = i + step; [state.beads[i], state.beads[j]] = [state.beads[j], state.beads[i]]; state.selectedBeadIndex = j; });
      }
      const empty = state.beads.filter(b => b.empty).length;
      const progress = document.createElement('p'); progress.className = 'completion-status'; progress.textContent = getSize() + ' cm · ' + (empty ? empty + ' perle' + (empty > 1 ? 's' : '') + ' à choisir' : lengthGuidance()) + ' · ' + formatEuro(totalPrice());
      ui.preview.querySelector('h2').after(progress);
      if (recent.length) {
        const box = document.createElement('div'); box.className = 'recent-stones';
        const label = document.createElement('p'); label.textContent = 'Vos dernières pierres'; box.append(label);
        recent.forEach(name => { const b = document.createElement('button'); b.className = 'ghost'; b.textContent = name; b.disabled = !available(name, state.selectedApplySizeMm); b.onclick = () => { state.selectedStoneName = name; render(); }; box.append(b); });
        ui.builder.querySelector('.catalog-tools').before(box);
      }
      ui.preview.querySelector('#applyStoneAll').disabled = state.beads.some(b => !available(state.selectedStoneName, b.sizeMm));
      if (!inventoryValid()) announce('Une pierre de cette composition n’est plus disponible en quantité suffisante. Remplacez-la avant de poursuivre.');
    }

    function render() {
      const focused = document.activeElement;
      const focusedId = ZEN_ROOT.contains(focused) ? focused.id : '';
      const catalogScroll = ui.builder.querySelector('#catalog')?.scrollTop || 0;
      const sequenceScroll = ui.preview.querySelector('.bead-sequence')?.scrollTop || 0;
      persistDraft();
      renderBuilder();
      renderPreview();
      renderProject();
      renderStudio();
      ZEN_ROOT.querySelectorAll('button').forEach(button => { button.type = 'button'; });
      if (focusedId) ZEN_ROOT.querySelector('#' + focusedId)?.focus({ preventScroll: true });
      ui.builder.querySelector('#catalog').scrollTop = catalogScroll;
      ui.preview.querySelector('.bead-sequence').scrollTop = sequenceScroll;
      persistDraft();
    }

    let cartBusy = false;
    let cartConfirmed = false;
    let pendingAdd = '';
    let pendingPrice = 0;
    try { const savedAdd = JSON.parse(sessionStorage.getItem('zenencens-pending-cart') || 'null'); if (savedAdd && typeof savedAdd.id === 'string' && Number.isInteger(savedAdd.priceCents)) { pendingAdd = savedAdd.id; pendingPrice = savedAdd.priceCents; } } catch { /* Storage unavailable or legacy pending state. */ }
    function clearPendingAdd() { pendingAdd = ''; pendingPrice = 0; try { sessionStorage.removeItem('zenencens-pending-cart'); } catch {} }
    let reviewed = false;
    let restoreBlocked = false;
    let saveMessage = '';
    let notice = '';
    let recent = [];
    let myStoneIds = [];
    let activeStep = 1;
    let cartResult = '';
    const eventOnce = new Set();
    function track(event) {
      if (['bracelet_started', 'bracelet_completed'].includes(event)) {
        if (eventOnce.has(event)) return;
        eventOnce.add(event);
      }
      // The store can subscribe and forward only after its own consent checks.
      ZEN_ROOT.dispatchEvent(new CustomEvent('zenencens:analytics', { bubbles: true, detail: { event, beadCount: state.beads.length, sizeCm: getSize() } }));
    }
    function available(name, size) {
      const stone = getStone(name);
      if (!stone.supportedSizes.includes(Number(size))) return false;
      const entry = ZEN_CONFIG.inventory?.[stone.id]?.sizes?.[size];
      return !entry || (entry.available !== false && (entry.quantity === undefined || entry.quantity > 0));
    }
    function inventoryValid() {
      const counts = {};
      for (const b of state.beads) {
        const key = getStone(b.stoneName).id + ':' + b.sizeMm;
        counts[key] = (counts[key] || 0) + 1;
        const entry = ZEN_CONFIG.inventory?.[getStone(b.stoneName).id]?.sizes?.[b.sizeMm];
        if (!available(b.stoneName, b.sizeMm) || (entry?.quantity !== undefined && counts[key] > entry.quantity)) return false;
      }
      return true;
    }
    function announce(message) {
      notice = message;
      const node = ZEN_ROOT.querySelector('#studioNotice');
      if (node) node.textContent = message;
    }
    function confirmAction(title, message, action) {
      const dialog = document.createElement('dialog');
      dialog.className = 'zen-dialog';
      const heading = document.createElement('h2'); heading.textContent = title;
      const copy = document.createElement('p'); copy.textContent = message;
      const cancel = document.createElement('button'); cancel.textContent = 'Garder mon bracelet'; cancel.className = 'ghost';
      const accept = document.createElement('button'); accept.textContent = 'Confirmer'; accept.className = 'primary-btn';
      cancel.type = 'button'; accept.type = 'button';
      const close = () => { dialog.close(); dialog.remove(); };
      cancel.onclick = close; accept.onclick = () => { close(); action(); };
      dialog.addEventListener('cancel', () => dialog.remove());
      dialog.append(heading, copy, cancel, accept); ZEN_ROOT.append(dialog); dialog.showModal(); cancel.focus();
    }
    function changeSizing(cm, base) {
      const proposed = state.beads.map(b => ({ ...b, sizeMm: base === state.baseBeadSizeMm ? b.sizeMm : base }));
      const result = ZenCore.rebalance(proposed, cm, base, state.selectedBeadIndex, 5);
      const change = () => {
        mutateComposition(() => { state.braceletSizeCm = cm; state.baseBeadSizeMm = base; state.selectedApplySizeMm = base; state.beads = result; }, true);
        track('size_selected'); announce('Taille mise à jour : ' + cm + ' cm, ' + result.length + ' perles. Annuler permet de retrouver votre composition précédente.');
      };
      if (result.length < state.beads.length) confirmAction('Ajuster votre composition ?', 'Cette taille nécessite ' + result.length + ' perles au lieu de ' + state.beads.length + '. Des perles seront retirées à la fin de la composition selon l’ajustement existant. Vous pourrez annuler.', change);
      else change();
    }

    syncBeads();
    loadSavedComposition();
    render();
    track("customizer_opened");
    if (SHOPIFY_PRODUCT.quoteUrl) {
      fetch(SHOPIFY_PRODUCT.quoteUrl.replace(/\/quote$/, '/catalog'), { signal: AbortSignal.timeout(15000) })
        .then(response => { if (!response.ok) throw new Error('Catalogue indisponible'); return response.json(); })
        .then(data => { if (ZEN_ROOT.isConnected) { ZEN_CONFIG.inventory = data.inventory; render(); } })
        .catch(error => { console.warn('ZenEncens inventory:', error); announce('La disponibilité des pierres sera vérifiée avant l’ajout au panier.'); });
    }
    const unload = event => {
      if (event.target === ZEN_ROOT || event.target.contains(ZEN_ROOT)) {
        destroyPremiumViewer();
        for (const material of premiumMaterialCache.values()) { material.map?.dispose(); material.dispose(); }
        premiumMaterialCache.clear();
        document.removeEventListener('shopify:section:unload', unload);
      }
    };
    document.addEventListener('shopify:section:unload', unload);
})();


}
if (!window.__zenStudioLifecycleBound) {
  window.__zenStudioLifecycleBound = true;
  document.addEventListener('shopify:section:load', initializeZenSections);
}
})();

// Refresh Dawn's basket after customizer additions without opening a second modal.
(function bindZenCartDisplay() {
  if (window.__zenCartDisplayBound) return;
  window.__zenCartDisplayBound = true;
  let pending = false;
  let revision = 0;
  const cartUrl = () => (window.Shopify?.routes?.root || '/') + 'cart';
  document.addEventListener('click', event => {
    if (!pending || !event.target.closest?.('#cart-icon-bubble')) return;
    // A failed display refresh must never open a stale/empty basket drawer.
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(cartUrl());
  }, true);
  document.addEventListener('zenencens:cart-added', async () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    pending = true;
    const current = ++revision;
    try {
      const response = await fetch(cartUrl() + '?sections=cart-drawer,cart-icon-bubble', {
        credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000)
      });
      if (!response.ok) throw new Error('Basket display unavailable');
      const sections = await response.json();
      if (current !== revision) return;
      const parser = new DOMParser();
      const body = typeof sections['cart-drawer'] === 'string' && parser.parseFromString(sections['cart-drawer'], 'text/html');
      const bubble = typeof sections['cart-icon-bubble'] === 'string' && parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      const fresh = body && body.querySelector('#CartDrawer');
      const freshBubble = bubble && bubble.querySelector('.shopify-section');
      const target = drawer.querySelector('#CartDrawer');
      const icon = document.getElementById('cart-icon-bubble');
      if (!fresh || !freshBubble || !target || !icon) throw new Error('Basket display incomplete');
      target.innerHTML = fresh.innerHTML;
      icon.innerHTML = freshBubble.innerHTML;
      drawer.classList.toggle('is-empty', !!body.querySelector('cart-drawer.is-empty'));
      drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
      pending = false;
    } catch {
      // The item is already added. Do not invite a duplicate POST for a display failure.
      console.warn('Zenencens: basket display refresh failed; basket link will load the cart page.');
    }
  });
})();
